// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "content-1yNcJ";
var _3 = "serviceCard-123Ln";
var _4 = "serviceCard_insurance-R0XM9";
var _5 = "services-2PW9C";
var _6 = "passenger-3qFib";
var _7 = "passengerName-2MPGE";
var _8 = "service-2p1Eo";
var _9 = "name-37qzh";
var _a = "price-1axuu";
var _b = "totalRefund-2543o";
var _c = "serviceCard_header-3w0LK";
var _d = "serviceCard_content-26zQE";
var _e = "serviceCard_header__icon-1hgjl";
var _f = "serviceCard_footer-1GgSM";
var _10 = "serviceCard_baggage-2sTb-";
var _11 = "serviceCard_meal-1uQoL";
var _12 = "serviceCard_seats-1xyWU";
export { _1 as "__esModule", _2 as "content", _3 as "serviceCard", _4 as "serviceCard_insurance", _5 as "services", _6 as "passenger", _7 as "passengerName", _8 as "service", _9 as "name", _a as "price", _b as "totalRefund", _c as "serviceCard_header", _d as "serviceCard_content", _e as "serviceCard_header__icon", _f as "serviceCard_footer", _10 as "serviceCard_baggage", _11 as "serviceCard_meal", _12 as "serviceCard_seats" }
export default { "__esModule": _1, "content": _2, "serviceCard": _3, "serviceCard_insurance": _4, "services": _5, "passenger": _6, "passengerName": _7, "service": _8, "name": _9, "price": _a, "totalRefund": _b, "serviceCard_header": _c, "serviceCard_content": _d, "serviceCard_header__icon": _e, "serviceCard_footer": _f, "serviceCard_baggage": _10, "serviceCard_meal": _11, "serviceCard_seats": _12 }
